export default __webpack_public_path__ + "i18n/translations/translation-fr.b53f7d6f.json";